export default __webpack_public_path__ + "static/media/chronic.f0f1c963.png";